/* Personal information is rendered by Shopify for the current customer only.
   Revalidate history restores rather than displaying a previously cached page
   after sign-out. Do not persist account data in browser storage. */
(() => {
  if (window.vitalAccountHistoryInstalled) return;
  window.vitalAccountHistoryInstalled = true;
  window.addEventListener('pageshow', event => {
    if (event.persisted && document.querySelector('[data-vital-account]')) {
      window.location.reload();
    }
  });
  function installPopup(root) {
    if (root.dataset.popupInstalled) return;
    root.dataset.popupInstalled = 'true';
    const popup = root.querySelector('shopify-account');
    if (!popup) return;
    const position = () => {
      const header = document.querySelector('.market-header');
      const top = Math.max(12, Math.ceil(header?.getBoundingClientRect().bottom || 0) + 12);
      popup.style.setProperty('--shopify-account-dialog-position-top', top + 'px');
    };
    popup.addEventListener('open',position);
    window.addEventListener('resize',position,{passive:true});
    // Shopify owns the sign-in popup. After it closes, check the current
    // storefront session so successful inline sign-in refreshes the dashboard.
    let checking = false;
    popup.addEventListener('close', async () => {
      if (checking || root.dataset.signedIn === 'true') return;
      checking = true;
      try {
        const response = await fetch(location.href,{cache:'no-store',credentials:'same-origin'});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        if (html.querySelector('[data-vital-account]')?.dataset.signedIn === 'true') location.reload();
      } catch { /* User can retry sign-in without losing the page. */ }
      finally { checking = false; }
    });
    position();
  }
  document.querySelectorAll('[data-vital-account]').forEach(installPopup);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-vital-account]').forEach(installPopup));
})();